import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { ProductTomos } from './components/ProductTomos';
import { RecipeCarousel } from './components/RecipeCarousel';
import { Bonuses } from './components/Bonuses';
import { CoachSection } from './components/CoachSection';
import { ResultsTimeline } from './components/ResultsTimeline';
import { Testimonials } from './components/Testimonials';
import { UrgencyBanner } from './components/UrgencyBanner';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="flex w-full min-h-full flex-col bg-white font-sans" data-id="element-0" data-mp="23vcikoy874a1">
      <Hero data-id="element-1" data-mp="23t8i6gzjcnei" />
      <PainPoints data-id="element-2" data-mp="23ti67z10skhk" />
      <Solution data-id="element-3" data-mp="3ik7k0rkruvvx" />
      <ProductTomos data-id="element-4" data-mp="3ikqytzf4l45q" />
      <RecipeCarousel data-id="element-5" data-mp="3ijfwm41bw4gq" />
      <Bonuses data-id="element-6" data-mp="3ihv0i9zd8dgr" />
      <CoachSection data-id="element-7" data-mp="3mljaezbgzl56" />
      <ResultsTimeline data-id="element-8" data-mp="3ml12h5fg3ihf" />
      <Testimonials data-id="element-9" data-mp="3mk85uxa7a9d0" />
      <UrgencyBanner data-id="element-10" data-mp="3mjq3diwy2ywn" />
      <FAQSection data-id="element-11" data-mp="3mj6lu3b7icj5" />
      <FinalCTA data-id="element-12" data-mp="3rbr9en3irte8" />
      <Footer data-id="element-13" data-mp="3rbzpsoyupgu6" />
      <StickyMobileCTA data-id="element-14" data-mp="3rdkh85pvcjnt" />
      <RecentPurchaseToast data-id="element-15" data-mp="3recdzjv7cnfo" />
      <div className="h-16 sm:hidden" aria-hidden="true" data-id="element-16" data-mp="5otf64sd496" />
    </div>;
}